let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iNMz2")).then(() => parcelRequire('ezxGc'));